export default function formatCurrency(
    numberToFormat: number | string,
    locale = 'it-IT',
    currency = 'EUR'
): string {
    let price = numberToFormat

    if (typeof price === 'string') {
        price = parseFloat(price)
    }

    const NUMBER_FORMAT_STYLE = 'currency'
    const fractionDigits = Number.isInteger(price) ? 0 : 2

    return new Intl.NumberFormat(locale, {
        style: NUMBER_FORMAT_STYLE,
        currency,
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits,
    }).format(price)
}
